import { type SaleMode } from '@paulownia/shared/types';
import { cn } from '@paulownia/shared/lib/utils';
import { SALE_MODES } from './sale-mode-config';

interface SaleModeSelectorProps {
  value?: SaleMode;
  onChange: (mode: SaleMode) => void;
  className?: string;
}

export function SaleModeSelector({ value, onChange, className }: SaleModeSelectorProps) {
  return (
    <div className={cn('space-y-3', className)}>
      {SALE_MODES.map((option) => {
        const Icon = option.icon;
        const isSelected = value === option.mode;

        return (
          <button
            key={option.mode}
            type="button"
            onClick={() => onChange(option.mode)}
            className={cn(
              'w-full text-left p-4 rounded-lg border-2 transition-all',
              'hover:border-blue-300 hover:bg-blue-50/50',
              isSelected
                ? 'border-blue-500 bg-blue-50 ring-1 ring-blue-500'
                : 'border-gray-200 bg-white'
            )}
          >
            <div className="flex items-start gap-3">
              <div
                className={cn(
                  'flex-shrink-0 p-2 rounded-lg',
                  isSelected ? 'bg-blue-100 text-blue-600' : 'bg-gray-100 text-gray-500'
                )}
              >
                <Icon className="h-5 w-5" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span
                    className={cn(
                      'font-medium',
                      isSelected ? 'text-blue-900' : 'text-gray-900'
                    )}
                  >
                    {option.label}
                  </span>
                  {isSelected && (
                    <span className="px-2 py-0.5 text-xs rounded-full bg-blue-500 text-white">
                      Sélectionné
                    </span>
                  )}
                </div>
                <p className="text-sm text-gray-500 mt-0.5">{option.description}</p>
                <p className="text-xs text-gray-400 mt-1 italic">Ex: {option.example}</p>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}
